/**
 * Canonical wizard step id list — the single source of truth for the 8-value
 * navigation-target union previously hand-duplicated across:
 *   - `web/app-home/src/components/admin/blueprints/wizard/shared/BottomBar.tsx`
 *     (`StepId`)
 *   - `web/app-home/src/components/admin/blueprints/wizard/useWizardCueNavigation.ts`
 *     (`STEP_ORDER`)
 *   - `src/shared/schemas/sse-events.ts`
 *     (`StudioCuePayloadSchema`'s `navigate.step`)
 *
 * Deliberately distinct from the broader 13-value `cue.step` render-target
 * union in the shared cue schema (5 studio scenes + these 8) — that union is
 * out of scope for this module; do not derive it from here.
 *
 * Order is meaningful: it defines forward/backward navigation semantics
 * everywhere this list (or a lookup derived from it) is consumed.
 */
export const WIZARD_STEP_IDS = [
  'start',
  'identity',
  'cardType',
  'mapping',
  'surfaces',
  'quickActions',
  'detailPanel',
  'review',
] as const;

export type WizardStepId = (typeof WIZARD_STEP_IDS)[number];
